export const TIPO_PRODUTO = {
  TIPO_PRODUTO_ADESAO: 1,
  TIPO_PRODUTO_TAXA_ADMINISTRATIVA: 2,
  TIPO_PRODUTO_RATEIO: 3,
  TIPO_PRODUTO_RASTREADOR: 4,
  TIPO_PRODUTO_INSTALACAO_RASTREADOR: 5,
  TIPO_PRODUTO_ASSISTENCIA_24H: 6,
  TIPO_PRODUTO_CLUBE_BENEFICIOS: 7,
  TIPO_PRODUTO_DESCONTO: 8,
  TIPO_PRODUTO_RESVISTORIA: 9,
  TIPO_PRODUTO_CARRO_RESERVA: 10,
  TIPO_PRODUTO_CASCO: 12,
  TIPO_PRODUTO_OUTRO: 11,
  TIPO_PRODUTO_MENSALIDADE: 13,
};
